type BoardUsersAction = {
  type: "BOARD_USERS";
  payload: Record<string, any>;
};

type BoardUsersState = Record<string, any>;

const boardUsers = (state: BoardUsersState = {}, action: BoardUsersAction): BoardUsersState => {
  switch (action.type) {
    case "BOARD_USERS": {
      return action.payload;
    }
    default:
      return state;
  }
};

export default boardUsers;
